module.exports = __webpack_public_path__ + "img/3-5.1ba05dd4.png";